import { createStore } from './create-store';

type TState = {
  search: string;
};

type TActions = {
  setSearch: (value: string) => void;
};

export const useClientFiltersStore = createStore<TState & TActions>(
  (set) => ({
    search: '',
    setSearch: (search: string) => set((state) => ({ ...state, search })),
  }),
  'client-filters-store',
);
